export enum RevenueType {
    General = 1,
    Merchandising = 2,
}
